var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.81 272.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.44,0c50.12,0,75.18,19.92,75.18,59.75v27.3c0,25.06-9.5,40.89-28.49,47.48,19.78,5.28,29.68,20.32,29.68,45.11v32.84c0,18.99-6.27,33.7-18.79,44.12-12.53,10.42-30.47,15.63-53.81,15.63s-41.75-2.5-55.2-7.52v-35.61c16.09,6.07,32.31,9.1,48.67,9.1s27.43-2.44,33.24-7.32c5.8-4.88,8.71-12.07,8.71-21.57v-25.32c0-10.29-2.51-18-7.52-23.15-5.01-5.14-13.32-7.72-24.93-7.72h-28.09v-34.43h27.7c11.34,0,19.39-2.77,24.14-8.31,4.75-5.54,7.12-13.58,7.12-24.14v-23.74c0-9.23-2.77-16.29-8.31-21.17-5.54-4.88-16.56-7.32-33.04-7.32s-30.67,2.24-42.54,6.73V5.54C16.22,1.85,31.66,0,51.44,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.ce96d7edb4be6673d781d67e2c3a77f4.svg";
export { ForwardRef as ReactComponent };